import { Formik, Form } from "formik";
import * as Yup from "yup";
import MainLayout from "../../../layout";
import FormTextField from "../../../components/form/text";
import { FormImageField } from "../../../components/form/image";
import { FormTextAreaField } from "../../../components/form/text-area";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../../components/toast/successToast";
import errorToast from "../../../components/toast/errorToast";
import { useEffect, useState } from "react";
import ResetPasswordModal from "../../../components/modal/reset-password-modal";
import { FormDateField } from "../../../components/form/date";
import { FormDropDown } from "../../../components/form/dropdown";
import { api } from "../../../redux/apis/api";
import { FormToggleSwitch } from "../../../components/form/checkbox";

const EditUsers = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [openResetPassowrd, setOpenResetPassowrd] = useState(false);
  const [rolesDropDownList, setRolesDropDownList] = useState([]);
  const [departmentDropDownList, setDepartmentDropDownList] = useState([]);
  const [designationDropDownList, setDesignationDropDownList] = useState([]);

  const initialValues = {
    id: params?.id,
    role_id: data?.role_id ?? null,
    designation_id: data?.designation_id ?? null,
    department_id: data?.department_id ?? null,

    profile_picture: data?.profile_picture ?? "",
    name: data?.name ?? "",
    email: data?.email ?? "",
    date_of_birth: data?.date_of_birth ?? null,
    phone_number: data?.phone_number ?? "",
    enabled: data?.enabled ?? false,
    status: data?.status ?? null,

    gender: data?.gender ?? "",
    marital_status: data?.marital_status ?? "",
    current_address: data?.current_address ?? "",
    permanent_address: data?.permanent_address ?? "",

    emergency_contact_number: data?.emergency_contact_number ?? "",
    emergency_contact_name: data?.emergency_contact_name ?? "",
    emergency_contact_relation: data?.emergency_contact_relation ?? "",

    bank_account_number: data?.bank_account_number ?? "",
    bank_ifsc_code: data?.bank_ifsc_code ?? "",
    bank_name: data?.bank_name ?? "",
    bank_account_holder_name: data?.bank_account_holder_name ?? "",
    pan_number: data?.pan_number ?? "",
    aadhar_number: data?.aadhar_number ?? "",

    joining_date: data?.joining_date ?? null,
    leaving_date: data?.leaving_date ?? null,
    exit_interview_date: data?.exit_interview_date ?? null,

    office_email: data?.office_email ?? "",
    office_phone_number: data?.office_phone_number ?? "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Required").email("Invalid email"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    api
      .post(`/ffadmin/edit`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/admin/users/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/ffadmin/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const maritalOptions = [
    { label: "Married", value: "married" },
    { label: "Single", value: "single" },
    { label: "Divorced", value: "divorced" },
    { label: "Other", value: "other" },
  ];

  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Suspended", value: "suspended" },
    { label: "Left", value: "left" },
  ];

  const fetchRolesDropDownData = () => {
    api
      .post(`/ffadmin/role-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.rows?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setRolesDropDownList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchDesignationList = () => {
    api
      .post(`/ffadmin/designation-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.rows?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setDesignationDropDownList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchDepartmentList = () => {
    api
      .post(`/ffadmin/depatment-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.rows?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setDepartmentDropDownList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchRolesDropDownData();
    fetchDesignationList();
    fetchDepartmentList();
  }, []);

  return (
    <MainLayout>
      <ResetPasswordModal
        id={params?.id}
        isOpen={openResetPassowrd}
        onClose={() => setOpenResetPassowrd(false)}
      />
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  Admin Users - Edit
                </h2>
                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => naviagte("/admin/users/list")}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Save
                  </button>
                </div>
              </div>
              <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1">
                <p>Basic Details</p>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormImageField
                    name={"profile_picture"}
                    label={"profile picture"}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"name"}
                    label={"name"}
                    placeholder={`Enter your name`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"phone_number"}
                    label={"phone number"}
                    placeholder={`Enter phone number`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"email"}
                    label={"Email"}
                    placeholder={`Enter your email`}
                  />
                </div>

                <div className="my-4">
                  <FormDateField
                    name={"date_of_birth"}
                    label={"date of birth"}
                  />
                </div>
                <div className="my-4">
                  <FormToggleSwitch
                    name={"enabled"}
                    label={"enabled"}
                    value={values?.enabled}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="gender"
                    label="Gender"
                    options={genderOptions}
                    value={genderOptions?.find(
                      (item) => item?.value === values?.gender
                    )}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="marital_status"
                    label="marital status"
                    options={maritalOptions}
                    value={maritalOptions?.find(
                      (item) => item?.value === values?.marital_status
                    )}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"current_address"}
                    label={"Current address"}
                    placeholder={`Enter permanent address`}
                    rows={3}
                  />
                </div>
                <div className="my-4">
                  <FormTextAreaField
                    name={"permanent_address"}
                    label={"permanent address"}
                    placeholder={`Enter permanent address`}
                    rows={3}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="status"
                    label="status"
                    options={statusOptions}
                    value={statusOptions?.find(
                      (item) => item?.value === values?.status
                    )}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="department_id"
                    label="department"
                    options={departmentDropDownList}
                    value={departmentDropDownList?.find(
                      (item) => item?.value === values?.department_id
                    )}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="designation_id"
                    label="Designation"
                    options={designationDropDownList}
                    value={designationDropDownList?.find(
                      (item) => item?.value === values?.designation_id
                    )}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name="role_id"
                    label="Role"
                    options={rolesDropDownList}
                    value={rolesDropDownList?.find(
                      (item) => item?.value === values?.role_id
                    )}
                  />
                </div>
                <div className="my-4">
                  <FormDateField name={"joining_date"} label={"joining date"} />
                </div>
                <div className="my-4">
                  <FormDateField name={"leaving_date"} label={"leaving date"} />
                </div>
                <div className="my-4">
                  <FormDateField
                    name={"exit_interview_date"}
                    label={"exit interview date"}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"office_email"}
                    label={"office email"}
                    placeholder={`Enter office email`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"office_phone_number"}
                    label={"office phone number"}
                    placeholder={`Enter office phone number`}
                  />
                </div>
              </section>
              <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1">
                <p>Bank Details</p>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormTextField
                    name={"pan_number"}
                    label={"pan number"}
                    placeholder={`Enter pan number`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"aadhar_number"}
                    label={"aadhar number"}
                    placeholder={`Enter aadhar number`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"bank_account_number"}
                    label={"account number"}
                    placeholder={`Enter account number`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"bank_ifsc_code"}
                    label={"ifsc code"}
                    placeholder={`Enter ifsc code`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"bank_name"}
                    label={"bank name"}
                    placeholder={`Enter bank name`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"bank_account_holder_name"}
                    label={"account holder name"}
                    placeholder={`Enter your account holder name`}
                  />
                </div>
              </section>
              <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1">
                <p className="capitalize">emergency contact details</p>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormTextField
                    name={"emergency_contact_name"}
                    label={"emergency contact name"}
                    placeholder={`Enter emergency contact name`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"emergency_contact_number"}
                    label={"emergency contact number"}
                    placeholder={`Enter emergency contact number`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"emergency_contact_relation"}
                    label={"relation to"}
                    placeholder={`Enter relation to`}
                  />
                </div>
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default EditUsers;
